"use client";

import Link from "next/link";
import { Bot } from "lucide-react";
import { useUser } from "@/features/auth/hooks/useUser";
import { hasApiAccess } from "@/lib/auth/access";

/**
 * The way into /agentic (API keys, usage and agent setup). Shown to viewers
 * with API access: Studio, and admins on any plan. It renders nothing on the
 * server and until the session is read.
 */
export function AgenticButton() {
  const { user, plan } = useUser();
  if (!hasApiAccess(plan, user?.email)) return null;
  return (
    <Link
      href="/agentic"
      aria-label="Agentic"
      title="API keys, usage and agent setup"
      className="inline-flex flex-shrink-0 items-center gap-1.5 rounded-md border border-[#2dd4bf]/40 bg-[#2dd4bf]/10 px-2 py-1.5 text-[13px] font-medium text-[#5eead4] transition-colors hover:border-[#2dd4bf]/70 hover:bg-[#2dd4bf]/20 hover:text-white focus:outline-none focus:ring-2 focus:ring-[#2dd4bf]/30 sm:px-2.5"
    >
      <Bot className="h-3.5 w-3.5" aria-hidden="true" />
      <span className="hidden sm:inline">Agentic</span>
    </Link>
  );
}
